
import styled from "@emotion/styled";


export const CustomAccountActiveWrapper = styled.div(({ theme: { designTokens: DT }, isApplyCustomLayout, pathname }) => {

    if (!isApplyCustomLayout) return ``
    return `
        padding: 42px 32px;
        border-radius: 8px;
        border: 1px solid ${DT.T_COLOR_LINE_PRIMARY_LIGHT};
        background-color: ${DT.T_COLOR_BG_DEFAULT_BRIGHT};
        .active-account-wrapper {
            width: 428px;
            margin: 54px auto;
        }

    `;
});



// WEBPACK FOOTER //
// ./src/common/custom-layout/CustomAccountActive/style.jsx